// src/pages/BlogDetailPage.jsx
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { collection, getDocs, query, where, limit } from "../services/mysqlStore";
import { db } from "../services/mysqlStore";
import "./BlogDetailPage.css";

function formatDate(ts) {
  if (!ts?.toDate) return "";
  return ts.toDate().toLocaleDateString("en-CA", { day: "numeric", month: "long", year: "numeric" });
}

export default function BlogDetailPage() {
  const { slug } = useParams();
  const [blog, setBlog]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setNotFound(false);
      try {
        const q = query(collection(db, "blogs"), where("slug", "==", slug), limit(1));
        const snap = await getDocs(q);
        if (snap.empty) {
          setNotFound(true);
        } else {
          setBlog({ id: snap.docs[0].id, ...snap.docs[0].data() });
        }
      } catch (e) {
        console.error(e);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [slug]);

  if (loading) return <div style={{ padding: 80, textAlign: "center" }}>Loading...</div>;

  if (notFound || !blog) {
    return (
      <div style={{ padding: 80, textAlign: "center" }}>
        <h2>Post not found</h2>
        <Link to="/blogs" className="btn-primary" style={{ display: "inline-block", marginTop: 16 }}>
          ← Back to Blog
        </Link>
      </div>
    );
  }

  const paragraphs = (blog.content || "").split("\n").filter(p => p.trim());

  return (
    <div className="blog-detail-page">
      <div className="container" style={{ maxWidth: 760, padding: "48px 20px 80px" }}>
        <Link to="/blogs" className="blog-back-link">← Back to Blog</Link>

        <span className="blog-detail-date">{formatDate(blog.createdAt)} · {blog.author}</span>
        <h1 className="blog-detail-title">{blog.title}</h1>

        {blog.coverImageUrl && (
          <div className="blog-detail-cover">
            <img src={blog.coverImageUrl} alt={blog.title} />
          </div>
        )}

        <div className="blog-detail-content">
          {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
        </div>

        <div className="blog-detail-cta">
          <h3>Ready to get your project printed?</h3>
          <Link to="/products" className="btn-primary">Browse Products →</Link>
        </div>
      </div>
    </div>
  );
}
